import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    async getCensusPreferences() {
        let res = await Axios.get(`${baseURL}schedule/census-user-preference`);
        return res?.data?.response?.resources?.user_preferences ?? [];
    },
    async updateCensusPreferences(payload) {
        let res = await Axios.post(`${baseURL}schedule/census-user-preference`, payload);
        return res?.data || null;
    }
};
